<div style="height: 100%;">
<!--  <button id="search-panel" class="map-control-button" (click)="showSearchPanel.emit()">-->
<!--    <i class="icon ico-person-outline"></i>-->
<!--  </button>-->
  <div id="map" class="map" style="height: 100%">
  </div>
  <div id="custom-popup" class="ol-popup">
<!--    <div id="popup-content">-->
<!--      <div *ngIf="selectedFeature !== null">-->
<!--        <div *ngFor="let item of selectedFeature.getProperties() | keyvalue">-->
<!--          <p *ngIf="item.key !== 'geometry'">{{settings.translateEnglish(item.key)}}-->
<!--            : {{item.value.length < 20 ? item.value : ''}}</p>-->
<!--          <p *ngIf="item.value.length >= 20">{{item.value}}</p>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</div>
